import React, { useState, useRef, useEffect } from 'react';
import { Col, Row, Upload, Card } from 'antd';
import ImageComponent from '@pages/userComponents/image-component';
import EdenredTypo from '@pages/userComponents/typography';
import './drag-drop.scss';
import { images } from 'src/assets/img';
import { DeleteOutlined } from '@ant-design/icons';
import DotLoader from 'react-spinners/DotLoader';

const { Dragger } = Upload;

const DragNDrop = ({ uploadLoading, uploaded, setUploaded, file, setFile, postemployeeStart, employeeData }) => {
	const [hasErrorFile, setHasErrorFile] = useState(false);
	const [fileLists, setFileLists] = useState();
	const [loader, setLoader] = useState(false);
	const [lastmodified, setLastmodified] = useState(null);
	const [modalDrag, setModalDrag] = useState(false);
	const [error, setError] = useState(false);
	const allowedFileTypes = ['xls', 'xlsm'];
	useEffect(() => {
		console.log(employeeData?.validationMessage, 'food1');
		if (employeeData?.validationMessage?.length === 0 || employeeData?.validationMessage === undefined) {
			setHasErrorFile(false);
		} else {
			setHasErrorFile(true);
		}
	}, [employeeData]);
	console.log(hasErrorFile, 'food');
	const props = {
		accept: ['xls', 'xlsm'],
		multiple: false,
		onChange(info) {
			if (info.file.status === 'uploading') {
				let fileList = [...info.fileList];
				fileList = fileList.slice(-1);
				const file = fileList[0].originFileObj;
				// setFileUpload(file);
				postemployeeStart(file);

				console.log(info.fileList, 'info5');
				if (allowedFileTypes.indexOf(file.name && file.name.split('.').splice(-1)[0]) >= 0) {
					fileList = fileList.map((file) => {
						if (file.response) {
							file.url = file.response.url;
						}
						return file;
					});

					setUploaded(true);
					setError(false);
					setFileLists(fileList);
					setHasErrorFile(false);
				} else {
					setUploaded(false);
					setError(true);
					setFileLists([]);
				}
			}
		},
		onRemove() {
			setLastmodified('remove');
			setFileLists([]);
			setLoader(false);
			setHasErrorFile(false);
			setUploaded(false);
			setError(false);
		},
	};
	const onRemove = () => {
		setLastmodified('remove');
		setFileLists([]);
		setLoader(false);
		setHasErrorFile(false);
		setUploaded(false);
		setError(false);
	};

	const dummyRequest = ({ file, onSuccess }) => {
		setTimeout(() => {
			onSuccess('ok');
		}, 0);
	};
	console.log(fileLists, 'dsd');
	return (
		<>
			<Col xl={24} md={24} lg={24} className="dragger_card_containertopCont">
				{/* <FadeIn direction="bottom"> */}
				<Dragger status="uploading" {...props} customRequest={dummyRequest} fileList={fileLists} className={'dragger-newDragger'}>
					{uploadLoading ? (
						<Row justify="center" align="middle" style={{ height: '100vh', width: '100%' }}>
							<Col
								style={{
									position: 'absolute',
									top: 0,
									left: 0,
									right: 0,
									bottom: 0,
									zIndex: 2,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									width: '100%',
									height: '100%',
								}}>
								<DotLoader size={100} color={'#e91d24'} loading />
							</Col>
						</Row>
					) : (
						<Row className="Upload_row_1">
							<Col xl={24} md={24} lg={24} sm={24} xs={24}>
								{console.log('first', uploaded)}
								{!uploaded ? (
									<ImageComponent src={images.upload} className="tick" />
								) : (
									<ImageComponent src={hasErrorFile ? images.Error : images.tickcheck} />
								)}
							</Col>
							<Col xl={24} md={24} className="whole" style={{ display: uploaded === false ? 'block' : 'none' }}>
								<Col xl={24} md={24} lg={24} sm={24} xs={24} style={{ justifyContent: 'center', display: 'flex' }}>
									<EdenredTypo h6 bold>
										Drag and drop to upload
									</EdenredTypo>
								</Col>
								<Col xl={24} md={24} lg={24} sm={24} xs={24}>
									<EdenredTypo h6 className="forClickHere">
										Or click here
									</EdenredTypo>
									<p></p>
								</Col>
							</Col>
						</Row>
					)}
				</Dragger>
				{uploaded === true && (
					<Col style={{ display: 'flex', justifyContent: 'center', marginTop: '-62px', marginBottom: '49px' }}>
						<span className="filename">{fileLists?.[0]?.name}</span>
						<DeleteOutlined
							style={{ justifyContent: 'center', display: 'flex', alignItem: 'center', marginLeft: '10px' }}
							onClick={onRemove}
						/>
					</Col>
				)}
				{error && (
					<Col xl={21} md={21} sm={24} lg={21} xs={24} className="card_error" style={{ marginTop: 0 }}>
						<Card className="card_action">
							<Col xl={24} md={24} sm={24} xs={24} className="final">
								<Col xl={1} sm={3} xs={3} md={2}>
									<ImageComponent src={images.Error} className="error" />
								</Col>
								<Col xl={24} md={24} sm={24} xs={24} className="tip_web-view">
									Invalid format. Please upload one of these formats {allowedFileTypes.join()}
								</Col>
							</Col>
						</Card>
					</Col>
				)}
			</Col>
		</>
	);
};
export default DragNDrop;
